// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"epro-register_wrapper__hZJ6v","tableWrapper":"epro-register_tableWrapper__3U89j"};